<template>
    <v-dialog scrollable max-width="800" v-model="dialog" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ titleLabel }}
            </v-card-title>

            <v-card-text>
                <exercise-creator
                    ref="creator"
                    hide-title
                    hide-buttons
                    @success="onCreatorSuccess"
                    @loading="loading = $event"
                    @change:validation="isExerciseValid = $event"
                    @change:step="exerciseStep = $event"
                    :new-exercise="newEx"
                    :default-exercise="defaultExercise"
                    @cancel="hide"
                />
            </v-card-text>

            <v-card-actions class="pa-0">
                <v-row no-gutters>
                    <v-col v-if="exerciseStep > 0" cols="1">
                        <v-btn @click="carouselBack" :disabled="!isExerciseValid" x-large block depressed
                               color="backGroundPrimary" dark tile>
                            <v-icon>$left_arrow</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col :cols="exerciseStep > 0 ? 11 : 12">
                        <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                               :disabled="!isExerciseValid" @click="next" :loading="loading">
                            {{ continueLabel }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ExerciseCreator from "@/components/coach/routines/ExerciseCreator";
import {mapMutations, mapState} from "vuex";

export default {
    name: "ExerciseCreatorDesktopDialog",
    components: {ExerciseCreator},
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        defaultExercise: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
            newEx: null,
            isExerciseValid: false,
            exerciseStep: 0,
            loading: false,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'secondDialogActive']),
        titleLabel(vm = this) {
            return vm.defaultExercise ? vm.$t('exercises.edit_exercise') : vm.$t('exercises.create_exercise')
        },
        continueLabel(vm = this) {
            return vm.exerciseStep === 1 ? vm.$t('common.save') : vm.$t('common.continue')
        }
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setSecondDialogActive']),
        next() {
            const vm = this
            if (!vm.$refs.creator) return
            vm.$refs.creator.next()
        },
        show(payload = null) {
            const vm = this
            if (payload) vm.newEx = payload
            vm.dialog = true
            if (vm.isSecondDialog) {
                vm.setSecondDialogActive(true)
            } else {
                vm.setDialogActive(true)
            }
        },
        hide() {
            const vm = this
            vm.newEx = null
            vm.dialog = false
            vm.$emit('hide')
            if (vm.isSecondDialog) {
                vm.setSecondDialogActive(false)
            } else {
                vm.setDialogActive(false)
            }
            vm.$nextTick(() => {
                if (vm.$refs.creator) vm.$refs.creator.reset()
            })
        },
        onCreatorSuccess(exercise) {
            const vm = this
            if (vm.$refs.creator) vm.$refs.creator.reset()
            vm.$emit('success', exercise)
            vm.hide()
        },
        carouselBack() {
            const vm = this
            vm.$refs.creator.goBack()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        }
    }
}
</script>

<style scoped>

.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

</style>